import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { AUFTRAG_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { initialRequisitionSorting, requisitionColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { useIsPortalSession } from '@Contexts/session';
import { ApiRequisition, EnumFrontendLayoutSetting } from '@Model';
import { PortalRequisitionList } from '@Modules/Portal';
import { useListApi } from '@Hooks/useListApi';
import { RequisitionsRepository } from '@Repositories/Auftragsbearbeitung';

export function FrameListRequisition() {
    const isPortalSession = useIsPortalSession();

    // Customers get their own list; the ERP list below is untouched.
    if (isPortalSession) {
        return <PortalRequisitionList />;
    }

    return <ErpRequisitionList />;
}

function ErpRequisitionList() {
    const hasPermission = useHasPermission();

    const module = useListApi(RequisitionsRepository, AUFTRAG_API, ['Site']);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiRequisition>
            layoutSettingsContext={EnumFrontendLayoutSetting.RequisitionsTableLayout}
            name="RequisitionsList"
            columns={requisitionColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.AuftragsbearbeitungRequisitionsCreate)}
            useOnClickNavigation
            initialSorting={initialRequisitionSorting}
            fullSize
        />
    );
}
